import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router';

import PageLoader from '../loaders/pageLoader';

const DemoPage = lazy(() => import('../../components/pages/userAccount/requestDemo'));
const ErrorPage = lazy(() => import('../../components/pages/errorPage'));

export const demoRoutes = {
	path: '/request-demo',
	element: <Outlet />,
	children: [
		{
			index: true,
			element: (
				<Suspense fallback={<PageLoader />}>
					{globalThis.cardProvider.IS_AMEX_PROVIDER_SETUP ? <DemoPage /> : <ErrorPage />}
				</Suspense>
			),
		},
	],
};
